import { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'react-router'

import Icon from 'components/Shared/Icon/Index'
import IconLink from 'components/Shared/IconLink/Index'
import colors from 'components/utils/colors'


const StyledWrapper = styled.div`
  position: absolute;
  top: -16px;
  display: flex;
  font-size: 12px;
  color: ${colors.secondary20};
  align-items: center;
`

const HomeIcon = styled(IconLink)`
  padding: 5px 5px 5px 3px;
`

const RightArrowButton = styled(Icon).attrs(props => ({
  iconName: 'icon-arrow-right-small-8',
}))`
  &:before {
    color: ${colors.secondary70} !important;
  }
`

const BreadcrumbText = styled.div`
  padding: 5px;
`

const BreadcrumbLinkText = styled.div`
  padding: 5px;
  cursor: pointer;
  color: ${colors.primary35};
  font-weight: 600;
`

const BreadcrumbEntry = ({ text, url }) => {
  return url
    ? (
      <Link to={url}>
        <BreadcrumbLinkText>{text}</BreadcrumbLinkText>
      </Link>
      )
    : <BreadcrumbText>{text}</BreadcrumbText>
}

BreadcrumbEntry.propTypes = {
  text: PropTypes.string,
  url: PropTypes.string,
}

const Breadcrumbs = ({ entries }) => {
  return (
    <StyledWrapper>
      <Link to='/'>
        <HomeIcon iconName='icon-home-10' />
      </Link>
      {entries.map(({ text, url }) => {
        return (
          <Fragment key={`${text}${url}`}>
            <RightArrowButton />
            <BreadcrumbEntry text={text} url={url} />
          </Fragment>
        )
      })}
    </StyledWrapper>
  )
}

Breadcrumbs.propTypes = {
  entries: PropTypes.array.isRequired,
}

export default Breadcrumbs
